import Layout from '@/components/layout/Layout';

export default function Index() {
  return <Layout>Bee</Layout>;
}
